module.exports = __webpack_public_path__ + "img/logo-fifalotto-white4-tgonebet.b765aff0.png";